import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import Details from "./Details";
import Summary from "./Summary";
import SectionDetailsLink from "../common/SectionDetailsLink";
import SimpleModalCompact from "../../../common/ModalCompact/SimpleModalCompact";

const totalStorageSpace = 60;

function createDetailsRow(workspaceName, desiredStorageSpace) {
  return { workspaceName, desiredStorageSpace };
}

const detailsRows = [
  createDetailsRow("Batbyggaren 2355", 10),
  createDetailsRow("Kanalen 32", 50),
];

const StorageSpaceSection = ({ classes, storage }) => {
  const [openDetails, setOpenDetails] = useState(false);

  const toggleOpenDetails = () => {
    setOpenDetails(!openDetails);
  };

  useEffect(() => {
    

  }, [storage]);

  return (
    <>
      <Typography className={classes.sectionTitle}>
        <FormattedMessage id="admin.subscriptions.storageSpace.title" />
      </Typography>
      <Grid container item xs={12} md={4}>
        <Summary
          className={classes.sectionSummary}
          totalStorageSpace={storage?.storageUsage || 0}
        />
      </Grid>
      <SectionDetailsLink
        className={classes.sectionDetailsLink}
        onClick={toggleOpenDetails}
      />
      <SimpleModalCompact open={openDetails} onClose={toggleOpenDetails} title={<FormattedMessage id="admin.subscriptions.storageSpace.title" />}>
        <Details
          className={classes.sectionDetails}
          open={openDetails}
          rows={storage?.storageDetails || []}
        />
      </SimpleModalCompact>
    </>
  );
};

StorageSpaceSection.defaultProps = {
  classes: {},
};

StorageSpaceSection.propTypes = {
  classes: PropTypes.object,
};

export default StorageSpaceSection;
